// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "location__weather-1bs4f";
var _4 = "isMobile-1zZh2";
var _5 = "location-3Toh9";
var _6 = "flight-2KUdD";
var _7 = "card-2rSa5";
export { _1 as "__esModule", _2 as "tablet", _3 as "location__weather", _4 as "isMobile", _5 as "location", _6 as "flight", _7 as "card" }
export default { "__esModule": _1, "tablet": _2, "location__weather": _3, "isMobile": _4, "location": _5, "flight": _6, "card": _7 }
